// Multi-Theme System for Naim Web
// Green-based theme structure

// Light Theme - Mint Fresh (White & Green)
const lightTheme = {
  // Primary Background
  background: {
    primary: '#E8F5E9',        // Very light mint green
    secondary: '#F1F8E9',      // Light lime tint
    gradient: ['#E8F5E9', '#F1F8E9', '#FAFAFA'],
  },

  // Card & Surface Colors
  surface: {
    card: '#FFFFFF',           // Pure white cards
    cardBorder: '#C8E6C9',     // Soft green border
    cardShadow: 'rgba(76, 175, 80, 0.1)',
    elevated: '#FAFDFB',       // Slightly green-tinted white
  },

  // Text Colors
  text: {
    primary: '#1B5E20',        // Deep forest green
    secondary: '#2E7D32',      // Medium green
    tertiary: '#4CAF50',       // Standard green
    accent: '#388E3C',         // Bright green
    light: '#81C784',          // Light green
  },

  // Card-specific text (for text on white/light cards)
  cardText: {
    primary: '#1B5E20',        // Deep forest green
    secondary: '#2E7D32',      // Medium green
    tertiary: '#4CAF50',       // Standard green
  },

  // Card Controls & Buttons
  cardControls: {
    buttonBackground: '#E8F5E9',
    inputBackground: '#F8FAF8',
    inputBorder: '#A5D6A7',
    addButton: '#2E7D32',
    addButtonSuccess: '#43A047',
    favoriteActive: '#f87171',
    favoriteInactive: '#E8F5E9',
    favoriteIcon: '#2E7D32',
  },

  // Interactive Elements
  interactive: {
    primary: '#4CAF50',        // Green-500
    primaryHover: '#388E3C',   // Green-700
    secondary: '#81C784',      // Green-300
    success: '#43A047',        // Green-600
    warning: '#FF9800',        // Orange-500
    error: '#EF4444',          // Red-500
  },

  // Input & Form Elements
  input: {
    background: '#F8FAF8',
    border: '#A5D6A7',
    borderFocus: '#4CAF50',
    text: '#1B5E20',
    placeholder: '#81C784',
  },

  // Navigation & Menu
  navigation: {
    background: '#FFFFFF',
    backgroundSecondary: '#F8FAF8',
    border: '#C8E6C9',
    itemBackground: '#F8FAF8',
    itemBackgroundActive: '#E8F5E9',
    itemBackgroundHover: '#C8E6C9',
    itemText: '#2E7D32',
    itemTextActive: '#1B5E20',
  },

  // Status & Badges
  status: {
    online: '#43A047',
    offline: '#6B7280',
    warning: '#FF9800',
    error: '#EF4444',
    info: '#4CAF50',
  },

  // Shadows
  shadow: {
    sm: 'rgba(76, 175, 80, 0.05)',
    md: 'rgba(76, 175, 80, 0.1)',
    lg: 'rgba(76, 175, 80, 0.15)',
    xl: 'rgba(76, 175, 80, 0.2)',
  },

  // Price colors
  price: {
    text: '#2E7D32',
    background: 'rgba(76, 175, 80, 0.1)',
  },
};

// Forest Theme - Deep Emerald (Current naim-web dark style)
const forestTheme = {
  // Primary Background
  background: {
    primary: '#0f3a30',        // Deep forest green (original naim)
    secondary: '#1a4d40',      // Slightly lighter forest
    gradient: ['#0f3a30', '#1a4d40', '#0f3a30'],
  },

  // Card & Surface Colors
  surface: {
    card: '#1a4d40',           // Forest card
    cardBorder: 'rgba(255,255,255,0.1)',
    cardShadow: 'rgba(0,0,0,0.3)',
    elevated: '#256b5a',       // Elevated surface
  },

  // Text Colors
  text: {
    primary: '#e8f5e9',        // Light mint
    secondary: '#a5d6a7',      // Soft green
    tertiary: '#81c784',       // Medium green
    accent: '#69f0ae',         // Bright accent green
    light: 'rgba(255,255,255,0.6)',
  },

  // Card-specific text
  cardText: {
    primary: '#e8f5e9',        // Light mint
    secondary: '#a5d6a7',      // Soft green
    tertiary: '#81c784',       // Medium green
  },

  // Card Controls & Buttons
  cardControls: {
    buttonBackground: '#256b5a',
    inputBackground: 'rgba(37, 107, 90, 0.7)',
    inputBorder: 'rgba(165, 214, 167, 0.4)',
    addButton: '#4caf50',
    addButtonSuccess: '#69f0ae',
    favoriteActive: '#f87171',
    favoriteInactive: '#256b5a',
    favoriteIcon: '#81c784',
  },

  // Interactive Elements
  interactive: {
    primary: '#4caf50',        // Green-500
    primaryHover: '#43a047',   // Green-600
    secondary: '#2e7d32',      // Green-800
    success: '#69f0ae',        // Green accent
    warning: '#ffb74d',        // Amber-300
    error: '#ef4444',          // Red-500
  },

  // Input & Form Elements
  input: {
    background: 'rgba(37, 107, 90, 0.7)',
    border: 'rgba(165, 214, 167, 0.4)',
    borderFocus: '#4caf50',
    text: '#e8f5e9',
    placeholder: 'rgba(165, 214, 167, 0.7)',
  },

  // Navigation & Menu
  navigation: {
    background: 'rgba(15, 58, 48, 0.95)',
    backgroundSecondary: '#1a4d40',
    border: 'rgba(255,255,255,0.1)',
    itemBackground: 'transparent',
    itemBackgroundActive: 'rgba(255,255,255,0.1)',
    itemBackgroundHover: 'rgba(255,255,255,0.05)',
    itemText: '#a5d6a7',
    itemTextActive: '#ffffff',
  },

  // Status & Badges
  status: {
    online: '#69f0ae',
    offline: '#81c784',
    warning: '#ffb74d',
    error: '#ef4444',
    info: '#4caf50',
  },

  // Shadows
  shadow: {
    sm: 'rgba(0,0,0,0.1)',
    md: 'rgba(0,0,0,0.3)',
    lg: 'rgba(0,0,0,0.5)',
    xl: 'rgba(0,0,0,0.7)',
  },

  // Price colors
  price: {
    text: '#69f0ae',
    background: 'rgba(76, 175, 80, 0.15)',
  },
};

// Theme registry
const themes = {
  light: lightTheme,
  forest: forestTheme,
};

// Get theme by mode
export const getTheme = (mode = 'forest') => themes[mode] || themes.forest;

// Export themes for direct access
export { lightTheme, forestTheme };

// Default export
export default themes;
